import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { isEmpty } from "lodash";
import { useIsLogged } from "../../../../hooks/auth/use-is-logged/use-is-logged";
import { useAbilityRules } from "../../../../legacy/hooks/useAbilityRules";
import { AbilityRulesStore } from "../../../../legacy/stores/abilityRulesStore";

const ABILITY_RULES_RECOVERY_QUERY_KEY = ["abac", "ability-rules-recovery"] as const;

export function useAbilityRulesRecovery(): void {
  const isLogged = useIsLogged();
  const storedAbilityRules = useAtomValue(AbilityRulesStore);
  const { getAbilityRules } = useAbilityRules();
  const hasMissingAbilityRules = isEmpty(storedAbilityRules);

  useQuery({
    queryKey: ABILITY_RULES_RECOVERY_QUERY_KEY,
    queryFn: getAbilityRules,
    enabled: isLogged && hasMissingAbilityRules,
    retry: false,
  });
}
